export const LOAD_WORKTYPE = "LOAD_WORKTYPE";
export const LOADING_WORKTYPE = "LOADING_WORKTYPE";
export const LOADING_WORKTYPE_SUCCESS = "LOADING_WORKTYPE_SUCCESS";
export const WORKTYPE_SAVE_NOT = "WORKTYPE_SAVE_NOT";
export const WORKTYPE_SAVE_SUCCESS = "WORKTYPE_SAVE_SUCCESS";
